const { MODE, VITE_BASE_URL_DEV, VITE_BASE_URL_RELEASE, VITE_URL_DEV, VITE_URL_RELEASE, } = import.meta.env;

export const API_URL = MODE === "development" ? VITE_BASE_URL_DEV : VITE_BASE_URL_RELEASE;
export const APP_URL = MODE === "development" ? VITE_URL_DEV : VITE_URL_RELEASE;

export const FAVICON = MODE === "development"
    ? VITE_BASE_URL_DEV.replace(/\/api$/, "/images/favicon.png")
    : VITE_BASE_URL_RELEASE.replace(/\/api$/, "/images/favicon.png");
